import {inject, injectable} from 'inversify'
import {SingletonService} from '@/common/dependency.configs'
import HttpHandler from '@/common/services/connect/HttpHandler'
import type RestResponse from '@/common/data/RestResponse'
import type CacheableAxiosRequestConfig from '@/common/services/connect/CacheableAxiosRequestConfig'

@injectable()
@SingletonService
export class ProductLoanDetailService {
  constructor(@inject(HttpHandler) private httpHandler: HttpHandler) {}

  getAll(accountTypeId: number, config: CacheableAxiosRequestConfig = {}): Promise<RestResponse<Array<ProductLoanDetail>>> {
    return this.httpHandler.get(`{{boltsbranch}}/accounttype/${accountTypeId}/loan-detail`, config)
  }

  post(accountTypeId: number, dto: ProductLoanDetail): Promise<RestResponse<ProductLoanDetail>> {
    return this.httpHandler.post(`{{boltsbranch}}/accounttype/${accountTypeId}/loan-detail`, dto)
  }

  put(accountTypeId: number, dto: ProductLoanDetail): Promise<RestResponse<ProductLoanDetail>> {
    return this.httpHandler.put(
      `{{boltsbranch}}/accounttype/${accountTypeId}/loan-detail/${dto.accountLoanDetailId}`,
      dto
    )
  }
}

export interface ProductLoanDetail {
  accountLoanDetailId?: string //UUID
  accountTypeId: number
  loanType?: string
  loanOriginationSystemProductCode?: string
  loanOriginationSystemProcessType?: string
  securedBy?: string
  requestedAmountVisible?: boolean
  requestedAmountMinimum?: number
  requestedAmountMaximum?: number
}
